import { PageHeader } from '@/components/ui/page-header';
import { usePageTitle } from '@/hooks/usePageTitle';
import { ReceivingDocumentsTab } from '../components/ReceivingDocumentsTab';

export function ReceivingPage() {
  usePageTitle('Receiving');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Receiving"
        description="Receiving documents — dock quantity checks and bin assignment tracking"
      />
      <ReceivingDocumentsTab />
    </div>
  );
}
